import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ZbiorUszkodzen} from '../../../../../../shared/store/zbior-uszkodzen/zbiorUszkodzen';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {PakTenantService} from '../../../../../../shared/services/pak/pak-tenant.service';

@Component({
  selector: 'app-zbior-uszkodzen',
  templateUrl: './zbior-uszkodzen.component.html',
  styleUrls: ['./zbior-uszkodzen.component.scss'],
  animations: [
    trigger('open-close', [
      state('true', style({height: '*'})),
      state('false', style({height: '0px'})),
      transition('true <=> false', animate('200ms ease-in-out'))
    ])
  ]
})
export class ZbiorUszkodzenComponent {

  constructor(private pakTenantService: PakTenantService) {
  }

  @Input()
  zbiorUszkodzenPrzedmiotuId!: number;

  @Input()
  zbiorUszkodzen!: ZbiorUszkodzen;

  @Input()
  czyPrzedmiotZUszkodzeniem!: boolean;

  @Output()
  usunZbiorUszkodzenClick = new EventEmitter<{ zbiorUszkodzenPrzedmiotowId: number, zbiorUszkodzenId: string }>();

  @Output()
  usunUszkodzenieClick = new EventEmitter<{
    zbiorUszkodzenPrzedmiotowId: number,
    zbiorUszkodzenId: string,
    identyfikatorUszkodzenia: string
  }>();

  isOpen = false;

  kliknietoNaWiersz(): void {
    this.isOpen = !this.isOpen;
  }

  usunZbiorUszkodzen(event: { zbiorUszkodzenPrzedmiotowId: number, zbiorUszkodzenId: string }): void {
    this.usunZbiorUszkodzenClick.emit(event);
  }

  usunUszkodzenie(event: {
    zbiorUszkodzenPrzedmiotowId: number,
    zbiorUszkodzenId: string,
    identyfikatorUszkodzenia: string
  }): void {
    this.usunUszkodzenieClick.emit(event);
    setTimeout(() => {
      this.isOpen = true
    });
  }

  // Wysłanie eventu po zakończeniu animacji rozwijania zbioru uszkodzeń powiązane
  // z wymaganą informacją dla PAK dotyczacą zmiany rozmiaru okna samoobsługi
  afterAnimationEnd(): void {
    this.pakTenantService.emitViewChangedEvent();
  }

}
